// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__RNraJ","inline":"Gallery_inline__PqzGl"};